module.exports = __webpack_public_path__ + "files/15ec5db3619e9b903273fbe8e7c2234e.svg";